import BaseModel from '../base/BaseModel.model';
import Oficina from '../oficina.model';
import UsuarioRole from './usuarioRole.model';
import Role from './role.model';

export default class Usuario extends BaseModel {

    public oficinaId?: number | null;
    public institucionId?: number | null;
    public personaId?: number;
    public slogan?: string;
    public sobreMi?: string;
    public nombreUbicacion?: string;
    public telefono?: string;
    public flota?: string;
    public celular?: string;
    public imagenPerfil?: Array<any>;
    public imagenPerfilFondo?: Array<any>;
    public userName?: string;
    public email?: string;
    public personalEmail?: string;
    public password?: string;
    public tipo?: any;
    public oficina?: Oficina;
    public usuarioRoles: Array<UsuarioRole> = [];
    public roles: Array<Role>= [];
    public disabled?: boolean;
    public isAdmin: boolean = false;
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = 0;
        this.oficinaId = null;
        this.institucionId =null;
        this.personaId = 0;
        this.slogan = "";
        this.sobreMi = "";
        this.nombreUbicacion = "";
        this.telefono = "";
        this.flota = "";
        this.celular = "";
        this.userName = "";
        this.email = "";
        this.personalEmail = "";
        this.password = "";
        
        this.tipo = 0;
        this.imagenPerfil = [];
        this.imagenPerfilFondo = [];
        this.usuarioRoles = [];
        this.roles = [];
        this.oficina = new Oficina();
        this.disabled = false;
        this.isAdmin = false;
    }
}